export class Comment {
    constructor() {
        this.commentForms = document.querySelectorAll('form[data-comment-webinar]');
        this.addListener();
    }

    addListener() {
        document.addEventListener('ratedWebinar', (event) => {
            this.commentForms.forEach((form) => {
                form.classList.remove('is-active');

                if (parseInt(form.dataset.commentWebinar) === event.detail.webinar) {
                    this.updateCommentForm(form, event.detail.ratingValue);
                }
            })
        })
    };

    updateCommentForm(commentForm, ratingValue) {
        commentForm.classList.add('is-active');
        commentForm.querySelector('input[name="tx_vetagendacomments_comments[value]"]').value = ratingValue;

        let refuseButton = commentForm.querySelector('[data-comment-button="refuse"]');

        refuseButton.addEventListener('click', (event) => {
            commentForm.classList.remove('is-active');
        })

        commentForm.addEventListener('submit', (event) => {
            event.preventDefault();
            commentForm.classList.remove('is-active');
            if ((commentForm.querySelector('textarea[name="tx_vetagendacomments_comments[comment]"]')?.value ?? '').trim() === '') {
                return;
            }
            this.submitComment(commentForm);
        })
    }

    submitComment(commentForm) {
        const formData = new FormData(commentForm);
        const actionUrl = commentForm.getAttribute('action');

        fetch(actionUrl, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => {
            if (!response.ok) {
                return response.text().then(text => {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                });
            }

            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return response.json();
            } else {
                return response.text().then(text => {
                    throw new Error('Server returned HTML instead of JSON');
                });
            }
        })
        .then(data => {
            if (data.success) {
                console.log('Comment submitted successfully');
            } else {
                console.error('Comment submission failed:', data.message || 'Unknown error');
            }
        })
        .catch(error => {
            console.error('Error submitting comment:', error);
        });
    }
}